import { render, staticRenderFns } from "./Ramal.vue?vue&type=template&id=602ff3da&scoped=true&"
import script from "./Ramal.vue?vue&type=script&lang=js&"
export * from "./Ramal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ff3da",
  null
  
)

export default component.exports